<template>
  <div class="hello">
    <div class="container">
      <p class="msg">Broj poslatih zahteva RTS-u preko platforme </p>
      <span class="countNumber">{{ emailCountNumber }}</span>
      <div class="form" v-if="!msgSent">
        <div class="container-item">
          <label>Vaše ime</label>
          <input
            type="text"
            v-model="name"
            name="name"
            placeholder="Vaše ime"
          />
          <p v-if="nameError" class="error">Ovo polje je obavezno!</p>
        </div>
        <div class="container-item">
          <label>Vaša email adresa</label>
          <input
            type="email"
            v-model="userEmail"
            name="email"
            placeholder="Vaš email"
          />
          <p v-if="emailError" class="error">Ovo polje je obavezno!</p>
        </div>
        <div class="container-item">
          <label>Naslov email-a</label>
          <p>
            Klikom na dugmiće ispod možete izabrati neke od predloga naslova
          </p>
          <div class="buttons">
            <button class="option-btn" @click="changeSubject(naslovi[0])">
              Naslov 1
            </button>
            <button class="option-btn" @click="changeSubject(naslovi[1])">
              Naslov 2
            </button>
            <button class="option-btn" @click="changeSubject(naslovi[2])">
              Naslov 3
            </button>
          </div>
          <p class="disclamer">
            *ovo su generički primeri, pozivamo ih da ih klikom preuredite ili u
            potponosti sami napišite, kako bi svaki izgledao drugačije!
          </p>
          <input
            type="text"
            v-model="subject"
            name="subject"
            placeholder="Naslov email-a"
          />
          <p v-if="subjectError" class="error">Ovo polje je obavezno!</p>
        </div>
        <div class="container-item">
          <label>Poruka</label>

          <p>Klikom na dugmiće ispod možete izabrati neke od predloga poruka</p>
          <div class="buttons">
            <button class="option-btn" @click="changeMsg(poruke[0])">
              Poruka 1</button
            >.
            <button class="option-btn" @click="changeMsg(poruke[1])">
              Poruka 2
            </button>
            <button class="option-btn" @click="changeMsg(poruke[2])">
              Poruka 3
            </button>
          </div>

          <p class="disclamer">
            *ovo su generički primeri, pozivamo ih da ih klikom preuredite ili u
            potponosti sami napišite, kako bi svaki izgledao drugačije!
          </p>
          <textarea
            name="message"
            v-model="message"
            cols="30"
            rows="5"
            placeholder="Poštovani..."
          >
          </textarea>
          <p v-if="msgError" class="error">Ovo polje je obavezno!</p>
        </div>
        <div class="container-item">
          <a
            v-bind:href="
              'mailto:info@rts.rs, desk@rts.rs, beogradski_program@rts.rs, rtstv@rts.rs, damozdane@rts.rs, zabavniprogram@rts.rs, beogradski_program@rts.rs, ekotvlink@rts.rs, webdesk@rts.rs, sekretarijat.202@rts.rs, sekretarijatrb2@rts.rs, kontaktcentar@rts.rs, marketing.office@rts.rs, nekasepripremi@rts.rs, nenad@rts.rs,vckrkic@rts.rs, barbulovic@rts.rs?subject=' +
              subject +
              '&body=' +
              message
            "
            class="sendBtn"
            >Pošalji email RTS-u preko svog naloga</a
          >
          <p>
            Možete izabrati opciju da pošaljete preko sopstvenog mejla, koji će
            stajati kao pošiljalac (što preporučujemo), a možete poslati i preko
            naše aplikacije (gde će stajati generički mejl).
          </p>
          <a href="#" class="sendBtn" @click="sendEmail()"
            >Pošalji email RTS-u preko platforme</a
          >
          <p class="disclamer">
            Ne odgovaramo za neprimerene komentare, uvrede i moguće zloupotrebe
            ovog kanala za pisanje RTS – u. Apelujemo na građane da i ovom
            prilikom budemo dostojanstveni i pristojni, da budemo iskreni i
            istrajni, ali da ne dozvolimo bilo kakve uvrede, pretnje i
            neprimerene komentare. Želimo pristojnu Srbiju i za nju se borimo na
            takav način!
          </p>
        </div>
      </div>
      <div v-if="msgSent" class="msgSent">
        <h3>Hvala vam što ste poslali poruku RTS-u!</h3>
        <a href="#" class="sendBtn" @click="sendAgain()">Pošalji ponovo</a>
      </div>
      <p class="last-p">
        RTS plaćate Vi i RTS je odgovoran Vama, baš zato crpite pravo da se
        obratite RTS–u sa zahtevom da je neophodno posvetiti emisije
        izveštavanju o inicijativi građana o zabrani eksploatacije litijuma i
        bora! Možda nas RTS ne čuje kada im se obraćamo pojedinačno, ali svi
        zajedno jesmo glas koji nije moguće preskočiti, svi zajedno jesmo onaj
        glas koji donosi razliku. Kao onda prošle godine kada smo stotine
        hiljade nas podelili reklamu koju je RTS odbio da emituje, a koji su
        videli milioni, nakon čega smo pokrenuli najveće proteste u Srbiji u
        poslednje 22 godine! Ako nas bude barem 1000, itekako će nas čuti!
        Blokiraćemo im mejlove, zato što oni blokiraju istinu! Danas je dan da
        započnemo novu bitku i izborimo se za prostor na RTS – u, jer svi mi smo
        ti koji plaćaju RTS. Neka nas bude barem 1000!
      </p>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "MainVue",
  data() {
    return {
      emailCountNumber: 0,
      name: "",
      userEmail: "",
      email: "",
      subject: "",
      message: "",
      msgSent: false,
      naslovi: [
        "Naše pravo da znamo sve!",
        "Zašto nema priče o litijumu",
        "Mi vas plaćamo",
      ],
      poruke: [
        "Više od 300.000 građana je podržalo peticiju kojom se zahteva odlazak Rio Tinta iz Srbije! Više od 30.000 građana stajalo je po zimi, kiši i u redovima kako bi se borilo uz inicijativu kojom je predložen zakon o zabrani iskopavanja litijuma i bora. Mi smo građani koji se bore za našu zemlju, vodu i vazduh. Mi smo građani koji plaćaju Vaš rad i mi smo građani koji žele da RTS izveštava o važnosti ove teme. To je Vaš posao.",
        "Nakon niza  protesta, prikupljanja potpisa, performansa i velikih tenzija, čini se da je Rio Tinto ponovo na vratima. Smatram da je to tema o kojoj je neophodno čuti glas građana na RTS – u, to je tema koja zahteva da se izveštava o njoj, to je tema iza koje stoje desetine i stotine hiljada ljudi, a RTS i dalje ćuti. Želimo debatnu emisiju! Želimo priliku da se čuje struka!",
        "Mi Vas plaćamo! Na Vama je da izveštavate o problemu Rio Tinta, ali i svim drugim zagađenjima tačno, pravovremeno i objektivno. Na Vama je da govorite o ovim temama, da ih razrađujete i dozvolite ljudima iz struke, a ne samo političarima da govore o njima. Želimo obične građane, ali i struku, želimo dublju analizu pitanja problema Rio Tinta. To je Vaš posao gospodo!",
      ],
      nameError: false,
      emailError: false,
      subjectError: false,
      msgError: false,
    };
  },
  methods: {
    changeSubject: function (subject) {
      this.subject = subject;
    },
    changeMsg: function (msg) {
      this.message = msg;
    },
    sendEmail: function () {
      if (this.name !== "") {
        this.nameError = false;
        if (this.userEmail !== "") {
          this.emailError = false;
          if (this.subject !== "") {
            this.subjectError = false;
            if (this.message !== "") {
              this.msgError = false;
              axios
                .get(
                  "https://hooks.zapier.com/hooks/catch/9841582/bcymshf/?name='" +
                    this.name +
                    "'&userEmail='" +
                    this.userEmail +
                    "'&subject='" +
                    this.subject +
                    "'&msg=" +
                    this.message +
                    "'"
                )
                .then((response) => {
                  console.log(response);
                  axios
                    .get(
                      "https://podeli-promeni-backend.herokuapp.com/email-counts/63338b2d51d08227904f7a7c"
                    )
                    .then((response) => {
                      axios.put(
                        "https://podeli-promeni-backend.herokuapp.com/email-counts/63338b2d51d08227904f7a7c",
                        {
                          "count" : parseInt(response.data.count) + 1,
                        }
                      ).then(()=>{
                        this.getEmailCount();
                      });
                    });
                });
              this.msgSent = true;
            } else {
              this.msgError = true;
            }
          } else {
            this.subjectError = true;
          }
        } else {
          this.emailError = true;
        }
      } else {
        this.nameError = true;
      }
    },
    sendAgain: function () {
      this.message = "";
      this.subject = "";
      this.msgSent = false;
    },
    getEmailCount: function () {
      axios
        .get(
          "https://podeli-promeni-backend.herokuapp.com/email-counts/63338b2d51d08227904f7a7c"
        )
        .then((response) => {
          return (this.emailCountNumber = response.data.count);
        });
    },
  },
  beforeMount() {
    this.getEmailCount();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  padding: 25px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* max-width: 900px;
  margin: 0 auto; */
}
.container .container-item input,
textarea {
  display: block;
  padding: 10px 0px;
  padding-left: 10px;
  font-size: 15px;
  width: 100%;
  max-width: 500px;
}
textarea {
  min-height: 150px;
}
label {
  text-align: left;
  display: block;
  width: 100%;
  font-size: 20px;
  margin-top: 15px;
  margin-bottom: 10px;
  max-width: 510px;
  font-weight: bolder;
}
.container-item {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.buttons {
  display: flex;
  font-size: 15px;
  width: 100%;
  max-width: 510px;
  margin-left: -5px;
}
.buttons button {
  padding: 7px;
  font-size: 15px;
  font-weight: bolder;
  border-radius: 5px;
  margin-right: 10px;
}
.buttons button:hover {
  cursor: pointer;
}
.sendBtn {
  background: #14a466;
  border-radius: 5px;
  color: white;
  font-size: 17px;
  font-weight: bolder;
  padding: 15px;
  border: none;
  margin-top: 15px;
  display: inline-block;
  text-decoration: none;
}
.sendBtn:hover {
  cursor: pointer;
}
p {
  text-align: left;
  display: block;
  width: 100%;
  font-size: 14px;
  max-width: 510px;
  font-weight: bolder;
}
.disclamer {
  color: #fc7f80;
}
.option-btn {
  background-color: #182338;
  color: white;
  border: none;
}
.error {
  color: #f74343;
  font-style: italic;
}
.disclamer {
  font-style: italic;
  color: #f74343;
}
.msgSent h3 {
  margin-top: 20px;
}
.last-p {
  width: 100%;
  margin: 10px auto;
  max-width: 510px;
  /* padding: 0 10px; */
  text-align: justify;
  font-size: 1em;
  font-weight: 400;
}
.msg{
  /* font-size:  */
  text-align: center;
}
.countNumber {
  margin-top: 5px;
  font-size: 1.3em;
  font-weight: 900;
}
</style>
